module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "about"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about_content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "join"
  }, [_c('ul', {
    staticClass: "join_menu"
  }, [_c('li', {
    class: {
      active: _vm.all
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickHandler($event, 'all')
      }
    }
  }, [_vm._v("全部")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.product
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickHandler($event, 'product')
      }
    }
  }, [_vm._v("产品")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.technology
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickHandler($event, 'technology')
      }
    }
  }, [_vm._v("技术")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.design
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickHandler($event, 'design')
      }
    }
  }, [_vm._v("设计")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.operation
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickHandler($event, 'operation')
      }
    }
  }, [_vm._v("运营")])])]), _vm._v(" "), _c('div', {
    staticClass: "job_list"
  }, _vm._l((_vm.positions), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "job_item"
    }, [_c('div', {
      staticClass: "job_position"
    }, [_c('div', {
      staticClass: "job_title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "job_require"
    }, [_c('div', {
      staticClass: "job_require_title"
    }, [_vm._v("职位要求")]), _vm._v(" "), _c('div', {
      staticClass: "job_require_content"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.require)
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "job_content"
    }, [_c('div', {
      staticClass: "job_content_title"
    }, [_vm._v("工作内容")]), _vm._v(" "), _c('div', {
      staticClass: "job_content_text"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("../assets/images/about/aheader.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about_header_content"
  }, [_c('div', {
    staticClass: "about_desc"
  }, [_c('div', {
    staticClass: "about_logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/about/logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "about_text"
  }, [_c('div', {
    staticClass: "v_line"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_title"
  }, [_vm._v("维学教育科技")]), _vm._v(" "), _c('p', [_vm._v("北京维学教育科技有限公司是一家专注K12英语教育的移动互联网创业公司，\n          公司利用多年的英语教育经验，提供全方位的学习解决方案，并将成熟的智能教育技术与产品，\n          运用到学校更多的教与学场景，致力打造专注，知名的网络教育品牌。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('p', [_vm._v("Enjoy Studying")]), _vm._v(" "), _c('div', {
    staticClass: "v_line",
    staticStyle: {
      "background-color": "#7c7c7c"
    }
  }), _vm._v(" "), _c('p', [_vm._v("加入我们")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02d5b492","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 86
// module chunks = 0